import * as React from "react"

import { cn } from "@/lib/utils"

// Sizing follows concept2 prototype (docs/studio/design-concept2/src/primitives.jsx Textarea).
// width:100%, min-height 80, padding 8/12, rounded calc(var(--radius) - 2px),
// fontSize 14, resize vertical.
//
// Mirrors Input's classes (h-9 swapped for min-h-20 + py-2; resize-y added).
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-20 w-full resize-y rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  />
))
Textarea.displayName = "Textarea"

export { Textarea }
